var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","tabindex":"0"},on:{"focus":_vm.setFocus}},[_c('TerminalContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }